export default "__VITE_ASSET__BRRxh_zv__"